import { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const content: SxStyle = {};

export const stack: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
};

export const checkLabel: SxStyle = {
  mx: 0,
  '& .MuiFormControlLabel-label': {
    fontSize: (p) => p.typography.caption,
  },
};

export const emptyBox: SxStyle = {
  paddingRight: (p) => p.spacing(2),
};

export const col: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
};

export const row: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  gap: (p) => p.spacing(1),
};

export const typography: SxStyle = {
  fontSize: (p) => p.typography.body2,
};

export const dashed: SxStyleFunc<boolean | undefined> = (isPeople) => ({
  borderStyle: 'dashed',
  marginY: isPeople ? 0 : (p) => p.spacing(1.5),
});

export const label: SxStyle = {
  fontSize: (p) => p.typography.caption,
  mb: (p) => p.spacing(1),
  fontWeight: 700,
};

export const leftBox: SxStyle = {
  px: (p) => p.spacing(2),
  // mb:1
};

export const rightBox: SxStyle = {
  p: (p) => p.spacing(1.5, 2),
};

export const footer: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  p: (p) => p.spacing(1.5, 2),
};

export const rightSection: SxStyleFunc<boolean | undefined> = (_isPeople) => ({
  borderLeftWidth: '1px',
  borderLeftStyle: 'dashed',
  borderLeftColor: (p) => p.palette.grey[300],
});

export const leftSection: SxStyleFunc<boolean | undefined> = (isPeople) => ({
  justifyContent: isPeople ? 'space-between' : 'unset',
  pb: isPeople ? (p) => p.spacing(1.5) : (p) => p.spacing(1),
  pt: isPeople ? (p) => p.spacing(1.5) : 0,
});

export const csvLabel: SxStyle = {
  color: (p) => p.palette.grey[700],
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  my: 1,
};

export const flex: SxStyle = {
  flex: 1,
  width: '100%',
};

export const text: SxStyle = {
  color: (p) => p.palette.grey[500],
  fontSize: (p) => p.typography.pxToRem(10),
};

export const csvIcon: SxStyle = {
  color: (p) => p.palette.grey[600],
};

export const iconButton: SxStyle = {
  p: (p) => p.spacing(0.5),
};

export const description: SxStyle = {
  pt: 2,
  pl: 2,
};

export const ownerContentPopup: SxStyle = {
  color: (p) => p.palette.grey[500],
  fontSize: (p) => p.typography.pxToRem(10),
};

export const exportTemplateButtonWrapper: SxStyle = {
  width: '100%',
  gap: (p) => p.spacing(1),
};

export const exportTemplateWrapper: SxStyle = {
  padding: (p) => p.spacing(2),
};

export const form: SxStyle = {
  display: 'none !important',
};

export const loadingWrapper: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 'auto',
  gap: (p) => p.spacing(1),
  padding: (p) => p.spacing(15),
};
